import ProductListing from "./Index";
export default function CarrefourProducts() {
  return <ProductListing source="carrefour" />;
}
